import { fetchPartnerGroup } from 'legacy/lut/components/widgets/public/partner360/ELT/api/partnerGroup/fetchPartnerGroup'

export const getGroupMainHq = async (groupId: number) => {
  const data = await fetchPartnerGroup(groupId, true)
  return {
    mainHqPartnerName: data?.MainHQPartnerName || '',
    mainHqPartnerId: data?.MainHQPartnerId || '',
  }
}
